import { OptionCard } from './OptionCard'
import { OptionsGrid } from './styles/OptionCardStyles'
import { QuestionTitle } from './styles/SignUpFlowStyles'
import { PROJECT_STAGE_OPTIONS } from '../../constants/surveyOptions'

interface SurveyStepFrequencyProps {
  value: string | null
  onChange: (value: string) => void
}

export function SurveyStepFrequency({ value, onChange }: SurveyStepFrequencyProps) {
  return (
    <div>
      <QuestionTitle>Where is your current project at?</QuestionTitle>
      <OptionsGrid>
        {PROJECT_STAGE_OPTIONS.map((option) => (
          <OptionCard
            key={option.value}
            label={option.label}
            isSelected={value === option.value}
            onClick={() => onChange(option.value)}
            isMultiSelect={false}
          />
        ))}
      </OptionsGrid>
    </div>
  )
}
